function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logoutUser } from "../../redux/auth/authActions";

class Logout extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "componentDidMount", () => {
      // emit the event
      this.props.logoutUser();
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

}

export default withRouter(connect(null, {
  logoutUser
})(Logout));